import { render, staticRenderFns } from "./multipleMenuItem.vue?vue&type=template&id=1a39b8c0&scoped=true"
import script from "./multipleMenuItem.vue?vue&type=script&lang=js"
export * from "./multipleMenuItem.vue?vue&type=script&lang=js"
import style0 from "./multipleMenuItem.vue?vue&type=style&index=0&id=1a39b8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a39b8c0",
  null
  
)

export default component.exports